import React, { useState, useEffect, useRef } from "react";
import TelegramIcon from "@mui/icons-material/Telegram";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CloseIcon from "@mui/icons-material/Close";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  IconButton,
  Box,
  Typography,
  Button,
  TextField,
  Grid,
  Badge,
  Popover,
  ClickAwayListener,
  InputAdornment,
  CircularProgress,
  Menu,
  MenuItem,
  Divider,
} from "@mui/material";

import FavoriteIcon from "@mui/icons-material/Favorite";
import MySnackbar from "../Hooks/MySnackBar";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  fetchDeleteDiary,
  fetchUpdateDiary,
  fetchTodayPhotoLength,
  fetchLike,
  fetchSaveCommentToBackend,
} from "../Hooks/Api";
import { useQueryClient } from "react-query";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { TokenAtom, TokenInfo, NewPhotoStates } from "../Hooks/TokenAtom";

const PhotoDialog = ({
  open,
  onClose,
  date,
  photos,
  onDeleteSuccess,
  onUpdateSuccess,
}) => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [rTitle, setrTitle] = useState(""); // 메모 상태 추가
  const [rDiary, setrDiary] = useState(""); // 메모 상태 추가
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("success"); // 메시지 유형 설정
  const [like_count, setLike_count] = useState(0); // 메모 상태 추가
  const [likeList, setLikeList] = useState([]); // 빈 배열로 초기화
  const [isLiked, setIsLiked] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [comments, setComments] = useState(photos[0]?.replies || []);
  const [isLoadingComment, setIsLoadingComment] = useState(false);
  const [newComment, setNewComment] = useState("");
  const queryClient = useQueryClient(); // queryClient 가져오기
  const tokens = useRecoilValue(TokenAtom);
  const tokenInfo = useRecoilValue(TokenInfo);
  const setTodayPhotosCount = useSetRecoilState(NewPhotoStates);
  const [deleteAnchor, setDeleteAnchor] = useState(null);
  const openDelete = Boolean(deleteAnchor);
  const [modirTitle, setModirTitle] = useState("");
  const [modirMemo, setModirMemo] = useState("");
  const [newImages, setNewImages] = useState([]); // 새로 추가할 사진 파일
  const [newImagePreviews, setNewImagePreviews] = useState([]); // 미리보기 URL
  const imageInputRef = useRef(null);
  const [openPic, setOpen] = useState(false); // 큰 화면 모달 열림 여부
  const [selectedPhoto, setSelectedPhoto] = useState(null); // 선택한 사진

  useEffect(() => {
    if (isLiked) {
      const timer = setTimeout(() => {
        setIsLiked(false); // isLiked가 true가 된 후 0.5초 후에 다시 false로 변경
      }, 300); // 0.5초 동안 크기 변화
      return () => clearTimeout(timer); // 타이머를 정리하여 메모리 누수 방지
    }
  }, [isLiked]);

  useEffect(() => {
    if (photos) {
      setLike_count(photos[0].like_count);
      setLikeList([photos[0].likeList]);
      setrTitle(photos[0].title);
      setrDiary(photos[0].diary);
    }
  }, [photos]);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: 0, // 슬라이드 좌우 여백
    dotsClass: "slick-dots custom-dots",
  };

  const formatDateShort = (dateString) => {
    if (!dateString) return "";

    // "YYYY-MM-DD" 형식의 날짜 문자열에서 연도, 월, 일을 추출
    const [year, month, day] = dateString.split("-");

    // Date 객체를 사용하여 요일을 추출
    const date = new Date(`${year}-${month}-${day}`);
    const options = { weekday: "long" }; // 요일을 긴 형식으로 추출
    const dayOfWeek = date.toLocaleDateString("ko-KR", options);

    // 원하는 형식으로 변환
    return `${year}.${month}.${day}(${dayOfWeek})`;
  };

  const handleCancelDelete = () => {
    setOpenConfirmDialog(false);
  };

  const handleEditClickOpen = () => {
    setModirTitle(rTitle); // 입력창에 현재 값 세팅
    setModirMemo(rDiary);
    setNewImages([]);
    setNewImagePreviews([]);
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setNewImages([]);
    setNewImagePreviews([]);
    setEditOpen(false);
  };
  const handleCloseSnackBar = () => {
    setIsSnackBarOpen(false);
  };
  // Popover 열기
  const handleBadgeClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Popover 닫기
  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setDeleteAnchor(event.currentTarget);
  };
  const handleDeleteClose = () => {
    setDeleteAnchor(null);
  };

  const handleDeleteAnchorClick = () => {
    setOpenConfirmDialog(true);
    handleDeleteClose(); // 메뉴 닫기
  };
  const handleOpen = (photo) => {
    setSelectedPhoto(photo);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedPhoto(null);
  };

  // Popover가 열려있는지 확인
  const openPopover = Boolean(anchorEl);
  const popOpen = openPopover ? "simple-popover" : undefined;

  const handleAddComment = async () => {
    const newCommentObj = {
      id: photos[0]?.id,
      diffId: comments.length + 1,
      writer: tokenInfo?.first_name,
      content: newComment,
      diff: "photoDiary",
    };
    try {
      setIsLoadingComment(true);
      const status = await fetchSaveCommentToBackend(newCommentObj, tokens);
      if (status === 201) {
        queryClient.invalidateQueries(["photoDiarys"]);
        setComments([...comments, newCommentObj]);
        setNewComment("");
        setSnackBarMessage("댓글작성 성공");
        setSnackBarSeverity("success");
        setIsSnackBarOpen(true);
      } else {
        if (status === 401) {
          setSnackBarMessage("권한없음");
          setSnackBarSeverity("error");
          setIsSnackBarOpen(true);
        } else {
          setSnackBarMessage("서버오류");
          setSnackBarSeverity("error");
          setIsSnackBarOpen(true);
        }
        console.error("Failed to delete photo, status code:", status);
      }
    } catch (error) {
      setSnackBarMessage("통신오류");
      setSnackBarSeverity("error");
      setIsSnackBarOpen(true);
      console.error("Error handling delete click:", error);
    } finally {
      setOpenConfirmDialog(false);
      setIsLoadingComment(false);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const status = await fetchDeleteDiary(photos[0].batch_number, tokens);
      if (status === 204) {
        onDeleteSuccess(status);
        queryClient.invalidateQueries("photoDiarys");
        fetchTodayPhotoLength(tokens, setTodayPhotosCount);
        onClose(); // 다이얼로그 닫기
      } else {
        onDeleteSuccess(status);
        console.error("Failed to delete photo, status code:", status);
      }
    } catch (error) {
      console.error("Error handling delete click:", error);
    } finally {
      setOpenConfirmDialog(false);
    }
  };

  const handleUpdate = async () => {
    try {
      const status = await fetchUpdateDiary(
        photos[0].batch_number,
        modirTitle,
        modirMemo,
        tokens,
        newImages
      );
      if (status === 200) {
        setrTitle(modirTitle);
        setrDiary(modirMemo);
        onUpdateSuccess(status);
        queryClient.invalidateQueries("photoDiarys");
        handleEditClose();
      } else {
        onUpdateSuccess(status);
        console.error("Failed to delete photo, status code:", status);
      }
    } catch (error) {
      console.error("Error handling delete click:", error);
    }
  };

  const handleImageAdd = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setNewImages((prev) => [...prev, ...files]);
    const previews = files.map((f) => URL.createObjectURL(f));
    setNewImagePreviews((prev) => [...prev, ...previews]);
    e.target.value = ""; // 같은 파일 재선택 허용
  };

  const handleRemoveNewImage = (index) => {
    setNewImages((prev) => prev.filter((_, i) => i !== index));
    setNewImagePreviews((prev) => {
      URL.revokeObjectURL(prev[index]);
      return prev.filter((_, i) => i !== index);
    });
  };
  const handleFavoriteClick = async (id, writer) => {
    try {
      const status = await fetchLike(id, writer, tokens, 2);
      if (status === 200) {
        setIsLiked((prev) => !prev);
        queryClient.invalidateQueries(["photoDiarys"]);
        setSnackBarMessage("좋아요!!");
        setSnackBarSeverity("success");
        setIsSnackBarOpen(true);
      } else {
        if (status === 401) {
          setSnackBarMessage("권한없음");
          setSnackBarSeverity("error");
          setIsSnackBarOpen(true);
        } else if (status === 404) {
          setSnackBarMessage("사진없음");
          setSnackBarSeverity("error");
          setIsSnackBarOpen(true);
        } else {
          setSnackBarMessage("서버오류");
          setSnackBarSeverity("error");
          setIsSnackBarOpen(true);
        }
        console.error("Failed to delete photo, status code:", status);
      }
    } catch (error) {
      if (error.status === 406) {
        setSnackBarMessage("이미 눌렀습니다");
        setSnackBarSeverity("warning");
        setIsSnackBarOpen(true);
      } else {
        setSnackBarMessage("통신오류");
        setSnackBarSeverity("error");
        setIsSnackBarOpen(true);
      }
      console.error("Error handling delete click:", error);
    }
  };

  return (
    <>
      <style>
        {`
          .slick-track {
            display: flex !important; /* 'slick-track'을 flex 컨테이너로 설정 */
            align-items: center !important; /* 수직 중앙 정렬 */
          }
        `}
      </style>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: "#f5f4f2", // 전체 배경 색
            borderRadius: "12px", // 모서리 둥글게
          },
        }}
      >
        <DialogTitle sx={{ px: 2, pt: 1, pb: 0 }}>
          {" "}
          {/* 아래에 경계선 추가 */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: "#f5f4f2",
            }}
          >
            <Typography
              sx={{
                fontSize: "1.2rem",
                color: "#8c6744",
                whiteSpace: "nowrap", // 한 줄로 표시
                overflow: "hidden", // 넘치는 부분 숨기기
                textOverflow: "ellipsis", // ...으로 표시
              }}
            >
              {rTitle}
            </Typography>

            <>
              <IconButton onClick={handleClick} sx={{ px: 0 }}>
                <MoreHorizIcon />
              </IconButton>
              <Menu
                anchorEl={deleteAnchor}
                open={openDelete}
                onClose={handleDeleteClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                PaperProps={{
                  sx: {
                    py: 0, // 메뉴 상하 여백 제거
                  },
                }}
                MenuListProps={{
                  sx: {
                    pb: 0, // ul padding 제거
                    margin: 0, // ul margin 제거
                  },
                }}
              >
                <MenuItem
                  onClick={handleEditClickOpen}
                  sx={{
                    minHeight: 0, // 메뉴 항목 최소 높이 제거
                    color: "#B8860B",
                    py: 0, // 상하 padding 줄임
                    px: 2, // 좌우 padding
                  }}
                >
                  수정
                </MenuItem>
                <Divider
                  sx={{ mt: 0 + " !important", mb: " 4px !important" }}
                />{" "}
                <MenuItem
                  onClick={handleDeleteAnchorClick}
                  sx={{
                    minHeight: 0, // 메뉴 항목 최소 높이 제거
                    color: "red",
                    py: 0, // 상하 padding 줄임
                    px: 2, // 좌우 padding
                  }}
                >
                  삭제
                </MenuItem>
                <Divider
                  sx={{ mt: 0 + " !important", mb: " 4px !important" }}
                />{" "}
                {/* 메뉴 아이템 구분선, 여백 최소화 */}
                <MenuItem
                  onClick={handleDeleteClose}
                  sx={{
                    minHeight: 0, // 메뉴 항목 최소 높이 제거
                    py: 0,
                    px: 2,
                  }}
                >
                  취소
                </MenuItem>
              </Menu>
            </>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            px: 2,
            py: 1,
            overflowX: "hidden",
            overflowY: "auto",
            bgcolor: "#f5f4f2",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "pre-wrap",
              color: "#8c6744",
              my: 1,
            }}
          >
            {rDiary}
          </Typography>
          {/* 아래에 경계선 추가 */}

          <Slider {...settings}>
            {photos.map((photo, index) => (
              <Box
                key={index}
                sx={{
                  textAlign: "center",
                  height: "auto",
                  borderRadius: "8px",
                  // 배경색 추가.
                  px: 0,
                  pt: 1,
                  pb: 0,
                }}
              >
                <img
                  src={photo.image}
                  alt={photo.diary}
                  loading="lazy"
                  style={{
                    backgroundColor: "#f5f4f2",
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    marginBottom: "8px",
                    padding: "4px",
                  }}
                  onClick={() => handleOpen(photo)}
                />
              </Box>
            ))}
          </Slider>
          <Box
            sx={{
              pb: 0,
              px: 0,
              width: "100%",
              backgroundColor: "#f5f4f2",
              borderRadius: "0 0 8px 8px",
            }}
          >
            <Grid
              container
              alignItems="stretch" // 각 항목의 높이를 동일하게 설정
              justifyContent="space-between"
              sx={{ height: "100%" }} // 부모 Grid의 높이를 설정
            >
              <Grid item>
                <Badge
                  badgeContent={like_count}
                  overlap="circular"
                  onClick={handleBadgeClick}
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: "#B8860B", // ★ 원하는 HEX 색상 적용
                      color: "white", // 텍스트 색상
                      fontSize: "0.8rem", // 뱃지 내 텍스트의 크기 조절
                      height: "18px", // 뱃지의 높이 조절
                      minWidth: "18px", // 뱃지의 최소 너비 조절
                      padding: "0", // 패딩 제거로 크기 축소
                      transform: "scale(0.8) translate(30%, -30%)", // 크기 및 위치 조정
                    },
                  }}
                >
                  <IconButton
                    onClick={(event) => {
                      event.stopPropagation(); // 이벤트 전파 방지
                      handleFavoriteClick(photos[0].id, tokenInfo?.first_name);
                    }}
                    sx={{ pl: 0 }}
                  >
                    {isLiked !== undefined && ( // 조건부 렌더링
                      // <Grow in={isLiked} timeout={500}>
                      <FavoriteIcon
                        sx={{
                          color: "error.main", // 항상 빨간색으로 유지
                          transform: isLiked ? "scale(1.5)" : "scale(1)", // isLiked가 true일 때만 크기를 1.5배로 증가
                          transition: "transform 0.2s ease-in-out", // 0.3초 동안 크기 변환 애니메이션
                        }}
                      />
                      // </Grow>
                    )}
                    {/* <FavoriteIcon color="error" /> */}
                  </IconButton>
                  {/* Popover: 배지 클릭 시 나타나는 텍스트 */}
                  <Popover
                    id={popOpen}
                    open={openPopover}
                    anchorEl={anchorEl}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <ClickAwayListener onClickAway={handleClosePopover}>
                      <Typography
                        sx={{
                          p: 1,
                          fontSize: "0.8rem",
                          whiteSpace: "pre-line", // 줄바꿈을 적용하기 위한 속성
                        }}
                      >
                        {likeList && likeList.length > 0
                          ? likeList.join("\n") // 배열 요소들을 한 줄씩 연결
                          : "No likes yet"}
                      </Typography>
                    </ClickAwayListener>
                  </Popover>
                </Badge>
              </Grid>

              <Grid item>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 2,
                    color: "text.secondary",
                    textAlign: "right",
                    height: "100%",
                    display: "flex",
                    alignItems: "center", // 수직 중앙 정렬
                    justifyContent: "flex-end", // 수평 정렬을 오른쪽으로 유지
                  }}
                >
                  {formatDateShort(photos[0]?.date)}
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 2,
                    color: "text.secondary",
                    textAlign: "right",
                    height: "100%",
                    display: "flex",
                    alignItems: "center", // 수직 중앙 정렬
                    justifyContent: "flex-end", // 수평 정렬을 오른쪽으로 유지
                  }}
                >
                  작성자: {photos[0]?.writer}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              width: "100%",
              px: 0,
              pb: 1,
              pt: 0,
              bgcolor: " #f5f4f2",
              borderRadius: "8px",
              mt: 0,
            }}
          >
            <Typography sx={{ fontSize: "1rem" }} gutterBottom>
              댓글
            </Typography>

            {/* Display existing comments */}
            {comments && comments.length > 0 ? (
              comments.map((comment, index) => (
                <Box key={index} sx={{ mb: 1, ml: 1 }}>
                  <Typography variant="body2" color="textSecondary">
                    {comment.writer}: {comment.content}
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography variant="body2" color="textSecondary"></Typography>
            )}
            <Grid container spacing={1} alignItems="center">
              <Grid item xs>
                <TextField
                  label="댓글을 작성해 주세요"
                  fullWidth
                  variant="outlined"
                  value={newComment}
                  size="small" // 텍스트 필드 사이즈 조정
                  onChange={(e) => setNewComment(e.target.value)}
                  InputLabelProps={{
                    sx: {
                      fontSize: "0.85rem",
                      color: "#8c6744", // 기본 라벨 색
                      "&.Mui-focused": {
                        color: "#8c6744", // 📌 라벨이 위로 올라갔을 때(포커스) 색상
                      },
                      "&.MuiFormLabel-filled": {
                        color: "#8c6744", // 📌 텍스트 입력되어 라벨이 위로 간 상태
                      },
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleAddComment}
                          disabled={isLoadingComment}
                        >
                          {isLoadingComment ? (
                            <CircularProgress size={24} />
                          ) : (
                            <TelegramIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: {
                      backgroundColor: "white",
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#8c6744",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#8c6744",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#8c6744",
                      },
                      "& .MuiInputBase-input": {
                        borderRadius: "8px",
                        backgroundColor: "white",
                        color: "#8c6744",
                      },
                      "& .MuiSvgIcon-root path": {
                        fill: "#8c6744",
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            bgcolor: "#f5f4f2",
            display: "flex",
            px: 2,
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              color: "#B8860B",
              borderColor: "#B8860B", // ← outlined 라서 border도 맞춰줘야 함
              "&:hover": {
                borderColor: "#DAA520",
                background: "#DAA520",
              },
            }}
          >
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      {/*수정 다이어로그 */}
      <Dialog
        open={editOpen}
        onClose={handleEditClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: "#f5f4f2", // 전체 배경 색
            borderRadius: "12px", // 모서리 둥글게
          },
        }}
      >
        <DialogTitle sx={{ color: "#8c6744", bgcolor: "#f5f4f2" }}>
          일기 수정
        </DialogTitle>
        <DialogContent
          sx={{
            bgcolor: "#f5f4f2",
            pt: "16px !important",
          }}
        >
          <Box sx={{ mb: 1 }}>
            <TextField
              label="제목"
              fullWidth
              multiline
              rows={1}
              value={modirTitle}
              onChange={(e) => setModirTitle(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f5f4f2",
                  "& fieldset": {
                    borderColor: "#c9b08a",
                  },
                  "&:hover fieldset": {
                    borderColor: "#b89263",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#8c6744",
                    borderWidth: "2px",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "#8c6744",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#8c6744",
                },
                /* ✨ 입력 텍스트 색상 변경 */
                "& .MuiInputBase-input": {
                  color: "#8c6744", // ← 원하는 텍스트 색상
                },
              }}
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              label="메모"
              fullWidth
              multiline
              rows={3}
              value={modirMemo}
              onChange={(e) => setModirMemo(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f5f4f2",
                  "& fieldset": {
                    borderColor: "#c9b08a",
                  },
                  "&:hover fieldset": {
                    borderColor: "#b89263",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#8c6744",
                    borderWidth: "2px",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "#8c6744",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#8c6744",
                },
                /* ✨ 입력 텍스트 색상 변경 */
                "& .MuiInputBase-input": {
                  color: "#8c6744", // ← 원하는 텍스트 색상
                },
              }}
            />
          </Box>
          {/* 사진 추가 영역 */}
          <Box sx={{ mb: 1 }}>
            <input
              ref={imageInputRef}
              type="file"
              accept="image/*"
              multiple
              style={{ display: "none" }}
              onChange={handleImageAdd}
            />
            <Button
              variant="outlined"
              startIcon={<AddPhotoAlternateIcon />}
              onClick={() => imageInputRef.current.click()}
              sx={{
                color: "#8c6744",
                borderColor: "#c9b08a",
                "&:hover": { borderColor: "#8c6744", background: "rgba(140,103,68,0.06)" },
                mb: newImagePreviews.length > 0 ? 1 : 0,
              }}
            >
              사진 추가
            </Button>
            {newImagePreviews.length > 0 && (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {newImagePreviews.map((src, i) => (
                  <Box key={i} sx={{ position: "relative", width: 80, height: 80 }}>
                    <img
                      src={src}
                      alt={`추가 사진 ${i + 1}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: 6,
                        border: "1px solid #c9b08a",
                      }}
                    />
                    <IconButton
                      size="small"
                      onClick={() => handleRemoveNewImage(i)}
                      sx={{
                        position: "absolute",
                        top: -8,
                        right: -8,
                        bgcolor: "white",
                        border: "1px solid #c9b08a",
                        p: "2px",
                        "&:hover": { bgcolor: "#fce4e4" },
                      }}
                    >
                      <CloseIcon sx={{ fontSize: 14, color: "#8c6744" }} />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleUpdate}
            variant="contained"
            sx={{
              background: "#B8860B", // 민트 → 초록
              color: "white",
              fontWeight: "bold",
              "&:hover": {
                background: "#DAA520", // hover 버전
              },
            }}
          >
            저장
          </Button>
          <Button
            onClick={handleEditClose}
            variant="outlined"
            sx={{
              color: "#B8860B",
              borderColor: "#B8860B", // ← outlined 라서 border도 맞춰줘야 함
              "&:hover": {
                borderColor: "#DAA520",
                background: "#DAA520",
              },
            }}
          >
            취소
          </Button>
        </DialogActions>
      </Dialog>
      {/* 삭제 확인 다이얼로그 */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCancelDelete}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>삭제 확인</DialogTitle>
        <DialogContent>
          <DialogContentText>
            정말로 이 사진을 삭제하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            취소
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="secondary"
            variant="contained"
          >
            삭제
          </Button>
        </DialogActions>
      </Dialog>
      {/* 큰 화면 모달 */}
      <Dialog
        open={openPic}
        onClose={handleClose}
        fullScreen
        PaperProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.9)",
          },
        }}
      >
        {/* 닫기 버튼 */}

        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            color: "white",
            zIndex: 10,
          }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>

        {/* 전체 사진 영역 */}
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={selectedPhoto?.image}
            alt=""
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Dialog>
      <MySnackbar
        open={isSnackBarOpen}
        onClose={handleCloseSnackBar}
        message={snackBarMessage}
        severity={snackBarSeverity}
      />
    </>
  );
};

export default PhotoDialog;
